import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ReviewsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { ReviewsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class ReviewsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getReviewsReport(filter: ReviewsReportFilterForm): Observable<DataWithPagination<ReviewsReport[]>> {
    return this.baseAPI.post(Constants.GET_REVIEWS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<ReviewsReport[]> = {
          data: this.mapper.fromListJson(ReviewsReport, res.data),
          count: res.count,
        };
        return data;
      })
    );
  }

  adminApproveReview(reviewId: string): Observable<string> {
    return this.baseAPI.post(Constants.ADMIN_APPROVE_REVIEWS_URL, { reviewId }).pipe(map((res) => res.message));
  }

  adminHideApproveReview(reviewId: string): Observable<string> {
    return this.baseAPI.post(Constants.ADMIN_HIDE_REVIEWS_URL, { reviewId }).pipe(map((res) => res.message));
  }
}
